'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _effects = require('redux-saga/effects');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (SubmissionError) {
  return _regenerator2.default.mark(function formSubmitSaga() {
    var _ref, _ref$meta, successActionType, failureActionType, resolve, reject, payload, _ref2, _ref3, _ref3$, success, failure;

    return _regenerator2.default.wrap(function formSubmitSaga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!true) {
              _context.next = 26;
              break;
            }

            _context.next = 3;
            return (0, _effects.take)(_common.FORM_SUBMIT);

          case 3:
            _ref = _context.sent;
            _ref$meta = _ref.meta;
            successActionType = _ref$meta.successActionType;
            failureActionType = _ref$meta.failureActionType;
            resolve = _ref$meta.resolve;
            reject = _ref$meta.reject;
            payload = _ref.payload;
            _context.next = 12;
            return [(0, _effects.race)({
              success: (0, _effects.take)(successActionType),
              failure: (0, _effects.take)(failureActionType)
            }), (0, _effects.put)(payload)];

          case 12:
            _ref2 = _context.sent;
            _ref3 = (0, _slicedToArray3.default)(_ref2, 1);
            _ref3$ = _ref3[0];
            success = _ref3$.success;
            failure = _ref3$.failure;

            if (!success) {
              _context.next = 22;
              break;
            }

            _context.next = 20;
            return (0, _effects.call)(resolve, success.payload);

          case 20:
            _context.next = 24;
            break;

          case 22:
            _context.next = 24;
            return (0, _effects.call)(reject, new SubmissionError(failure.payload));

          case 24:
            _context.next = 0;
            break;

          case 26:
          case 'end':
            return _context.stop();
        }
      }
    }, formSubmitSaga, this);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-form-submit-saga/lib/form-submit-saga.js
// module id = 1899
// module chunks = 1